import { Platform } from 'react-native';
import useNotify from '../../../../../../hooks/useNotify';
import { notifyBugsnag } from '../../../../../../utils/bugsnag';
import { getIntl } from '../../../../../../utils/intl';
import { csvHeaders } from '../types';

const intl = getIntl('bulkAddClientRecordsScreen-pendingFileContent-useDownloadTemplate', {
    errorDownloadingTemplate: 'Error downloading template',
    fileName: 'upload-clients-template.csv',
});

export type UseDownloadTemplateReturnValue = {
    downloadTemplate: () => void;
};

const generateCSVContent = () => {
    return csvHeaders.join(',') + '\n' + new Array(csvHeaders.length).fill('').join(',') + '\n';
};

export const useDownloadTemplate = (): UseDownloadTemplateReturnValue => {
    const notify = useNotify();
    const downloadTemplate = () => {
        // Only allow downloads on web platform
        if (Platform.OS !== 'web') {
            notify('error', intl('errorDownloadingTemplate'));
            return;
        }

        try {
            const blob = new Blob([generateCSVContent()], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = intl('fileName');
            a.style.display = 'none';
            document.body.appendChild(a);
            // Use dispatchEvent instead of click() for better browser compatibility
            a.dispatchEvent(
                new MouseEvent('click', {
                    view: window,
                    bubbles: false,
                    cancelable: true,
                }),
            );

            // Clean up: remove anchor and revoke object URL after a short delay to esnure the download completes first
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 500);
        } catch (error) {
            notifyBugsnag(error as any);
            notify('error', intl('errorDownloadingTemplate'));
        }
    };

    return {
        downloadTemplate,
    };
};
